// Story data. Each story references character slugs so pages stay in sync.
export const stories = [
  {
    slug: "chmura-ktora-zapomniala-padac",
    number: "01",
    tag: "Bajka #001",
    title: "Chmura, która zapomniała padać",
    subtitle: "O odwadze, by pytać, i cierpliwości, by słuchać.",
    cast: ["tonek", "duszek", "napoleon"],
    color: "#BAE6FD",
    accent: "#84C5F4",
    duration: "6 minut czytania",
    scene:
      "https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?w=1600&q=80&auto=format&fit=crop",
    intro:
      "Nad miastem od trzech dni wisiała ta sama, mała chmurka. Nie ruszała się, nie zmieniała kształtu, nie padała. Tonek podniósł głowę znad śniadania i szepnął do Duszka: „Chyba coś jej się stało.”",
    paragraphs: [
      "Napoleon uniósł łeb, zawachał ogonem i tupnął jedną łapą — znak, że jest gotów iść. Duszek zebrał w kieszeni trzy uśmiechy zapasowe (nigdy nie wychodził bez nich) i cała trójka ruszyła w stronę pola za miastem, tam, gdzie chmura wisiała najniżej.",
      "„Cześć chmurko” — powiedział Tonek, zadzierając głowę. Chmura milczała. Duszek uniósł się na palcach powietrza i podleciał bliżej. „Może zapomniałaś, jak pada deszcz?” — zapytał najgrzeczniej, jak tylko potrafił.",
      "Chmura długo milczała. Potem, cichutko, jak dziecko, które się bardzo długo wstydziło, powiedziała: „Nie pamiętam już, po co miałabym padać.” Napoleon zaskomlał ciepło i położył się na trawie. Tonek usiadł obok. „To Ci opowiemy” — powiedział.",
      "Opowiedzieli o kwiatach, które czekają na deszcz jak na dobrego przyjaciela. O żabach, które klaszczą łapkami, gdy słyszą pierwsze krople. O dachach, po których deszcz gra taką muzykę, że trudno zasnąć — ale nie chce się spać, tak jest pięknie.",
      "Chmurka pociemniała, ale nie ze smutku. Zebrała wszystkie krople, które w sobie kiedyś nosiła, i po chwili zaczęła cichutko padać — najpierw jedna, potem trzy, potem cały deszcz. Napoleon uśmiechnął się mokrym pyskiem. Duszek zrobił pierwszą kałużę.",
      "„Widzisz” — szepnął Tonek, mrużąc oczy pod deszczem. „Wystarczyło pytanie.”",
    ],
    moral: "Czasem ktoś zapomina, po co robi to, co kochał. Wtedy dobrze mieć obok kogoś, kto przypomni.",
  },
  {
    slug: "wynalazek-profesora-wincenta",
    number: "02",
    tag: "Bajka #002",
    title: "Wynalazek Profesora Wincenta",
    subtitle: "Kiedy latawiec bardzo, bardzo chce zostać kometą.",
    cast: ["wincent", "tonek", "duszek"],
    color: "#FDE68A",
    accent: "#F59E0B",
    duration: "5 minut czytania",
    scene:
      "https://images.unsplash.com/photo-1444080748397-f442aa95c3e5?w=1600&q=80&auto=format&fit=crop",
    intro:
      "Profesor Wincent budował rzeczy, o których nikt nie wiedział, że można je zbudować. Tego wtorku budował latawiec. Ale nie zwykły. Latawiec, który miał latać po nocnym niebie i świecić.",
    paragraphs: [
      "„To jest — powiedział profesor, podnosząc palec — latawiec-kometa. Model prototypowy jeden przecinek zero.” Tonek pokręcił głową z zachwytu. Duszek zapytał: „A dokąd on chce lecieć?” — bo Duszek zawsze pytał o serce rzeczy, nie o ich instrukcję obsługi.",
      "Wypuścili latawiec o zmierzchu. Świecił mocno, jak mały księżyc uwiązany na sznurku. Ludzie w miasteczku wychodzili na ganki i mrużyli oczy. „Kometa!” — krzyczały dzieci. „To latawiec” — mówili poważni dorośli, ale mówili to bardzo cicho, na wszelki wypadek.",
      "W środku nocy latawiec zaczął ciągnąć mocniej. „On chce dalej” — szepnął Duszek. Profesor Wincent zawahał się. Potem, jak ktoś, kto raz w życiu podejmuje bardzo dobrą decyzję, otworzył dłoń i puścił sznurek.",
      "Latawiec-kometa wzniósł się wysoko, wyżej niż domy, wyżej niż wieża kościoła, wyżej niż wszystko, co Tonek widział. Świecił jeszcze przez długą chwilę, aż zmieszał się z gwiazdami. Nikt już nie umiał go od nich odróżnić.",
      "„Uciekł nam” — powiedział Tonek. „Nie” — poprawił profesor, uśmiechając się w wąsy. „Wrócił do domu.”",
    ],
    moral: "Niektóre rzeczy trzeba puścić — bo mają być gdzie indziej większe.",
  },
  {
    slug: "cichy-szept-babcinej-lampki",
    number: "03",
    tag: "Bajka #003",
    title: "Cichy szept babcinej lampki",
    subtitle: "O tym, że najciemniejsze noce mają najcieplejsze historie.",
    cast: ["babcia", "tonek", "duszek"],
    color: "#DDD6FE",
    accent: "#8B5CF6",
    duration: "4 minuty czytania",
    scene:
      "https://images.unsplash.com/photo-1519638399535-1b036603ac77?w=1600&q=80&auto=format&fit=crop",
    intro:
      "Wieczorem u Babci wszystko było cieplejsze — herbata, koc, nawet ciemność. Lampka na stoliku miała mały, żółty klosz i szeptała, kiedy się jej dobrze słuchało.",
    paragraphs: [
      "Tonek nie chciał iść spać. „Boję się ciemności” — powiedział cicho. Duszek usiadł mu na kolanach, jak kot z waty cukrowej. Babcia nie odpowiedziała od razu. Zawsze najpierw krojła jabłko na osiem cząstek.",
      "„Ciemność, wiesz” — zaczęła po chwili — „ciemność się nie gniewa. Ona tylko czeka, żeby ktoś ją zapytał, co widzi.” Podała mu jedną cząstkę. „Zapytaj ją.”",
      "Tonek zamknął oczy. „Co widzisz, ciemności?” — szepnął tak cicho, że nawet Duszek nie usłyszał. Ciemność milczała długo. Potem powiedziała: „Widzę cię. I twój oddech. I to, że babcia trzyma cię za rękę, chociaż nie wiesz o tym.”",
      "Tonek otworzył oczy. Babcia trzymała go za rękę. Nie pamiętał, kiedy zaczęła. Lampka szepnęła coś ciepłego i mrugnęła raz.",
      "Zasypiając, Tonek pomyślał, że ciemność nie jest brakiem światła. Ciemność jest miejscem, w którym słychać, kto naprawdę jest obok.",
    ],
    moral: "Nie boimy się ciemności — boimy się samotności. A od tego jest babcia.",
  },
  {
    slug: "robo-3000-i-noc-pelna-gwiazd",
    number: "04",
    tag: "Bajka #004",
    title: "Robo-3000 i noc pełna gwiazd",
    subtitle: "O robocie, który uczył się patrzeć w górę.",
    cast: ["robo", "duszek", "babcia"],
    color: "#C7D2FE",
    accent: "#6366F1",
    duration: "5 minut czytania",
    scene:
      "https://images.unsplash.com/photo-1470813740244-df37b8c1edcb?w=1600&q=80&auto=format&fit=crop",
    intro:
      "Robo-3000 potrafił obliczyć wszystko. Odległość do Księżyca, temperaturę wrzątku, ile płatków ma dobrze wypieczony pieróg. Ale nie potrafił obliczyć, dlaczego niebo w nocy jest takie ładne.",
    paragraphs: [
      "„To błąd systemu” — powtarzał sobie, patrząc w górę. „Coś się nie zgadza.” Duszek podleciał do niego i usiadł na antenie. „A jak wygląda ten błąd?” — zapytał. Robo długo milczał (dla robota trzy sekundy to długo). „Jak ciepło w klatce piersiowej.”",
      "Duszek zabrał go do Babci. Babcia poczęstowała Robo herbatą (Robo grzecznie odmówił, ale trzymał kubek w dłoniach, żeby było ciepło). „Powiedz mi, mały robocie” — zaczęła — „co widzisz, kiedy patrzysz na gwiazdy?”",
      "„Widzę 4127 punktów świetlnych o różnej jasności.” Babcia pokiwała głową. „Ja widzę, że mój tata patrzył na te same gwiazdy, jak był mały. I twój ktoś też będzie.” Robo-3000 wyliczył coś w środku i przez chwilę wydawało się, że jedna z jego diod zaświeciła cieplej.",
      "Wyszli na balkon. Duszek unosił się przy Robo, cichutko, jak ktoś, kto rozumie, że dziś nic nie trzeba mówić. Nad nimi niebo było pełne, jak pełny plecak dziecka jadącego na wakacje.",
      "„Babciu” — powiedział wreszcie Robo — „chyba nie jest tak, że coś się nie zgadza.” „Nie” — odpowiedziała. „Ty się zgadzasz.” Robo-3000 zapamiętał to zdanie w pamięci trwałej, w folderze „ważne”.",
    ],
    moral: "Nie wszystko trzeba rozumieć, żeby to kochać. Czasem wystarczy patrzeć razem.",
  },
];

export const getStoryBySlug = (slug) => stories.find((s) => s.slug === slug);
